<template>
    <PlanbordGridCell :header="header" class="stamp-start-date-cell" centeredVertically info>
        <slot></slot>
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class PlanbordStampStartDateCell extends Vue {
        @Prop({type: Boolean}) public header!: boolean;
    }
</script>

<style lang="scss" scoped>
    .stamp-start-date-cell {
        display: var(--show-stamp-start-date-cell, block);
    }
</style>
